DJ.addBehavior('js-link-toggle', '.toggle_link_block', {
  attach: function (context, settings, behavior) {
    const self = jQuery(this);

    jQuery(this).find('.link-toggle').on('click', function () {
      self.addClass('showed');
    });
    jQuery(this).find('.toggle_link_block__button .link--with-arrow').on('click', function () {
      self.removeClass('showed');
    });
  },

  detach: function (context, settings) {}
});
